// ApiUrl.js
// export const BASE_URL = "http://145.79.0.94:8000";
export const API_BASE = "http://145.79.0.94:82";
